import React from "react";
import { routes } from "../../../../constants/routes";
import { Alert, Box, Typography } from "@mui/material";
import {
  AlertComponent,
  BreadcrumbComponent,
} from "../../../../common/components";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import "./crm-trail-plans.scss";
import { AntSwitch } from "../../../user-management/user-management-list/components/ant-switch";
import ViewPlanDetails from "../crm-paid-plans/view-plan-details";
import { useSetLoading } from "../../../../common/hooks/appearance";
import { getSubscriptionPlans } from "../../../../api/tenets";
import { AlertMessage } from "../../tenant-details/tenant-details-types";
import { getTrailPlans, validationSchema } from "../crm-plans-utils";
import { Form, Formik } from "formik";
import { toggleCRMPlanStatus } from "../../../../api/crm-plans";
import icons from "../../../../assets/icons/icons";

const breadcrumbLink = [
  {
    label: "CRM Plans",
    link: "#",
    handleClick: () => {},
  },
  {
    label: "Trial Plans",
    link: routes.CREATE_CRM_PLAN,
    handleClick: () => {},
  },
];

const labelSwitch = { inputProps: { "aria-label": "Switch demo" } };

const CrmTrailPlans = () => {
  const [indexValue, setIndexValue] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const [plans, setPlans] = React.useState<any>({});
  const [alertMessage, setAlertMessage] = React.useState<AlertMessage>({
    open: false,
  });

  const getSubscriptionValues = async () => {
    try {
      setIsLoading(true);
      const response = await getSubscriptionPlans({ planCategory: "trial" });
      const resPlans = response?.data?.data || [];

      const { plans } = getTrailPlans(resPlans);
      setPlans(plans);
      setIsLoading(false);
    } catch (e: any) {
      setIsLoading(false);
      setAlertMessage({
        open: true,
        message:
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          e?.message ||
          "Some thing went wrong!",
        type: "error",
      });
      console.error(e);
    }
  };

  React.useEffect(() => {
    getSubscriptionValues();
  }, []);

  const handleActiveToggle = async (planId: any, payload: any) => {
    try {
      setIsLoading(true);
      const res = await toggleCRMPlanStatus(planId, payload);
      const updatedPlans = [...plans];
      updatedPlans[indexValue].active = payload.status;
      setPlans([...updatedPlans]);
      setAlertMessage({
        open: true,
        message:
          res?.data?.data?.message || "Active status updated successfully.",
        type: "success",
      });

      setIsLoading(false);
    } catch (e: any) {
      setIsLoading(false);
      setAlertMessage({
        open: true,
        message:
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          e?.message ||
          "Some thing went wrong!",
        type: "error",
      });
    }
  };

  const showLoading = React.useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);

  return (
    <Box className="crm-paid-plans-wrapper crm-trail-plans-wrapper">
      <Box>
        <BreadcrumbComponent breadcrumbLink={breadcrumbLink} />
      </Box>
      <Box className="crm-trail-plans-container">
        <Formik
          initialValues={plans[indexValue]}
          validationSchema={validationSchema}
          enableReinitialize
          validateOnBlur
          onSubmit={(values) => {
            // addTenet(temp, values);
          }}
        >
          {({ resetForm }) => (
            <Form>
              <Box className="tab-edit">
                <Box className="tab-section">
                  <Tabs
                    value={indexValue}
                    onChange={(
                      event: React.SyntheticEvent,
                      newValue: number
                    ) => {
                      setIndexValue(newValue);
                      resetForm({ values: plans[newValue] });
                    }}
                    allowScrollButtonsMobile
                    variant="scrollable"
                  >
                    <Tab label="7 Days" />
                    <Tab label="14 Days" />
                    <Tab label="1 Month" />
                    <Tab label="3 Months" />
                    <Tab label="6 Months" />
                    <Tab label="1 Year" />
                  </Tabs>
                </Box>
              </Box>
              <Box>
                {plans?.[indexValue]?.planName && (
                  <Box className="paid-plans-switch">
                    <AntSwitch
                      {...labelSwitch}
                      checked={plans?.[indexValue]?.active || false}
                      onChange={(e) => {
                        const activePlan = plans[indexValue];
                        handleActiveToggle(activePlan?.id, {
                          status: !activePlan?.active,
                        });
                        // setFieldValue("status", e.target.checked ? "ACTIVE" : "INACTIVE")
                      }}
                    />
                    <Typography className="paid-plans-status">
                      Active
                    </Typography>
                  </Box>
                )}
              </Box>
              {plans?.[indexValue]?.planName ? (
                <ViewPlanDetails
                  activeTab={indexValue}
                  title="Trial"
                  plans={plans[indexValue]}
                  setPlans={setPlans}
                  allPlans={plans}
                />
              ) : (
                <>
                  {/* <Alert severity="info">
                  No plans available. Create a free trial plan for this period.
                </Alert> */}
                  <div className="roles-partner-placeholder">
                    <img src={icons.TrailEmptyIcon} />
                    <p>
                      No trial plans found for the selected period. Please
                      create a plan to view the details.  
                    </p>
                  </div>
                </>
              )}
            </Form>
          )}
        </Formik>
      </Box>
      {alertMessage?.open && (
        <AlertComponent
          message={alertMessage?.message}
          type={alertMessage?.type || "error"}
          open={alertMessage?.open}
          onClose={() => {
            setAlertMessage({ open: false });
          }}
        />
      )}
    </Box>
  );
};

export default CrmTrailPlans;
